// AppActionSection.tsx
import React from "react";
import { ActionSection, Body, Container, Title, ActionGroup } from "./styled";
import { Button } from "Components/Form";
import { FormButtonProps } from "Components/Form/Button";
import { useTranslation } from "react-i18next";

// Posições possíveis para os botões
export type ButtonPosition = "left" | "center" | "right";

// Interface para configuração de cada botão
export interface ButtonConfig {
  label: string;
  onClick?: () => void;
  variant?: "contained" | "outlined" | "text";
  color?: FormButtonProps["customColor"];
  disabled?: boolean;
  loading?: boolean;
  position?: ButtonPosition; // Nova propriedade para posição do botão
  className?: string; // Opcional: para estilos customizados adicionais
}

interface AppActionSectionProps {
  title?: string;
  children?: React.ReactNode;

  // Props para customização dos botões
  buttons?: ButtonConfig[];
  showActionSection?: boolean;

  // Props para customização de cada seção
  leftContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const AppActionSection = (props: AppActionSectionProps) => {
  const {
    title,
    children,
    buttons = [
      { label: "Cancel", position: "left" },
      { label: "Update", position: "right" },
    ],
    showActionSection = true,
    leftContent,
    centerContent,
    rightContent,
  } = props;

  // Agrupar botões por posição
  const leftButtons = buttons.filter((button) => button.position === "left" || !button.position);
  const centerButtons = buttons.filter((button) => button.position === "center");
  const rightButtons = buttons.filter((button) => button.position === "right");

  // Renderiza os botões para uma posição específica
  const renderButtons = (buttonsToRender: ButtonConfig[]) => {
    return buttonsToRender.map((button, index) => (
      <Button
        key={index}
        onClick={button.onClick}
        variant={button.variant}
        customColor={button.color}
        disabled={button.disabled}
        className={button.className}
        loading={button.loading}
      >
        {button.label}
      </Button>
    ));
  };

  return (
    <Container>
      <Body>
        {title && <Title>{title}</Title>}
        {children}
      </Body>

      {showActionSection && (
        <ActionSection>
          {/* Seção Esquerda */}
          <ActionGroup position="left">{leftContent || renderButtons(leftButtons)}</ActionGroup>

          {/* Seção Central */}
          <ActionGroup position="center">
            {centerContent || renderButtons(centerButtons)}
          </ActionGroup>

          {/* Seção Direita */}
          <ActionGroup position="right">{rightContent || renderButtons(rightButtons)}</ActionGroup>
        </ActionSection>
      )}
    </Container>
  );
};
